import script from "./ProjectUpdateConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectUpdateConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./ProjectUpdateConfirmation.vue?vue&type=style&index=0&id=5ae0ff86&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae0ff86"]])

export default __exports__